export default __webpack_public_path__ + "static/4-b43df9e9191da1c33fe80e94ffce8242.jpg";